import { gql } from '@apollo/client';
import {
  Button,
  CardSection,
  CardSectionControl,
  CardSectionDescription,
  CardSectionTitle,
  Group,
} from '@apollo/orbit';
import React from 'react';
import { Link, useLocation } from 'react-router-dom';

import { LazyUrlModal } from 'src/components/common/LazyUrlModal';
import { PermissionWarning } from 'src/components/permissionGuards/permissionWarning/PermissionWarning';
import { Config } from 'src/lib/config/config';
import { format } from 'src/lib/format';
import { GraphQLTypes } from 'src/lib/graphqlTypes';
import { setOverlayVisibleLocation } from 'src/lib/routing';

import { NumberOfApproversModal } from '../approvalsAndPermissionsCard/numberOfApproversModal/NumberOfApproversModal';

export const ApproversRequiredSectionServiceFragment = gql`
  fragment ApproversRequiredSectionServiceFragment on Service {
    id
    minProposalApprovers
  }
`;

export const ApproversRequiredSection = ({
  graph,
}: {
  graph: GraphQLTypes.ApproversRequiredSectionServiceFragment;
}) => {
  const location = useLocation();

  return (
    <>
      <CardSection className="flex-row">
        <Group orientation="vertical">
          <CardSectionTitle>Required approvals</CardSectionTitle>
          <CardSectionDescription className="max-w-[760px]">
            All proposals on this graph require at least{' '}
            <span className="font-semibold">{graph.minProposalApprovers}</span>{' '}
            {format.pluralize(graph.minProposalApprovers, 'approval')}.
          </CardSectionDescription>
        </Group>
        <CardSectionControl>
          <PermissionWarning
            graphId={graph.id}
            graphPermissions="canManageProposalPermissions"
            childRenderer={(hasPermission) => (
              <Button
                variant="secondary"
                isDisabled={!hasPermission}
                as={Link}
                to={setOverlayVisibleLocation({
                  location,
                  overlayName: Config.modals.editProposalNumberOfApprovers,
                })}
              >
                Manage required approvals
              </Button>
            )}
          />
        </CardSectionControl>
      </CardSection>
      <LazyUrlModal name={Config.modals.editProposalNumberOfApprovers}>
        {({ closeModal, isOpen }) => (
          <NumberOfApproversModal
            isOpen={isOpen}
            onClose={closeModal}
            minProposalApprovers={graph.minProposalApprovers}
          />
        )}
      </LazyUrlModal>
    </>
  );
};
